var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 16.5H18.3333C18.8375 16.5 19.25 16.0875 19.25 15.5833C19.25 15.0792 18.8375 14.6667 18.3333 14.6667H3.66667C3.1625 14.6667 2.75 15.0792 2.75 15.5833C2.75 16.0875 3.1625 16.5 3.66667 16.5ZM3.66667 11.9167H18.3333C18.8375 11.9167 19.25 11.5042 19.25 11C19.25 10.4958 18.8375 10.0833 18.3333 10.0833H3.66667C3.1625 10.0833 2.75 10.4958 2.75 11C2.75 11.5042 3.1625 11.9167 3.66667 11.9167ZM2.75 6.41667C2.75 6.92083 3.1625 7.33333 3.66667 7.33333H18.3333C18.8375 7.33333 19.25 6.92083 19.25 6.41667C19.25 5.9125 18.8375 5.5 18.3333 5.5H3.66667C3.1625 5.5 2.75 5.9125 2.75 6.41667Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenuIcon);
export default __webpack_public_path__ + "static/media/HamburgerMenuIcon.85c1bbf1f2fd585ac3f4fc92bb534602.svg";
export { ForwardRef as ReactComponent };